---
title: "Paket-Lebenszyklus"
slug: package-lifecycle
description: "Von unterwegs bis bezahlt: die vier Phasen, die ein Paket bei einem externen Empfänger durchläuft."
keywords:
  - Lebenszyklus
  - Paket
  - Unterwegs
  - Rechnung
  - Rückgabe
  - Empfänger
  - Erinnerung
---

## Der Lebenszyklus eines Pakets beim externen Empfänger

Sobald Sie ein Paket an einen externen Standort senden, durchläuft es automatisch vier Phasen. hey circle überwacht diesen Prozess und versendet Erinnerungen sowie Rechnungen, ohne dass Sie eingreifen müssen.

## Phase 1: Unterwegs

Das Paket wurde gescannt und an den externen Empfänger gesendet. Es befindet sich außerhalb Ihres internen Bestands und hat den Status **"Unterwegs"**.

In dieser Phase liegt das Paket beim Empfänger. Es ist weder verloren noch verrechnet — es wird auf seine Rückkehr gewartet.

## Phase 2: Empfänger erinnert

Kehrt das Paket nach einer festgelegten Frist nicht zurück, sendet hey circle automatisch eine **Erinnerungsbenachrichtigung** an den Empfänger.

Die Erinnerung informiert ihn, dass das Paket zur Rückgabe fällig ist. Sie als Admin oder Manager werden gleichzeitig in der Übersicht benachrichtigt, welche Pakete überfällig sind.

## Phase 3: Rechnung versendet

Gibt der Empfänger das Paket nicht zurück, erstellt hey circle automatisch eine **Rechnung** und versendet sie. Die Rechnung deckt die Nutzungsdauer oder den Pauschalpreis für das Paket ab, je nach Ihren Vertragseinstellungen.

Sie können den Status in der Analysenansicht nachverfolgen.

## Phase 4: Bezahlt und aus Inventar entfernt

Sobald die Rechnung beglichen ist (oder das Paket doch noch zurückgegeben wird), wechselt der Status auf **"Abgeschlossen"**. Das Paket wird aus dem ausstehenden Inventar entfernt.

Wird das Paket zurückgegeben (eingescannt bei einem internen Standort), wird der Rechnungsprozess gestoppt und das Paket kehrt in den Status **"Verfügbar"** zurück.

## Überblick auf einen Blick

| Phase | Status | Was passiert |
|---|---|---|
| 1 | Unterwegs | Paket beim externen Empfänger |
| 2 | Unterwegs (Erinnerung) | Automatische Erinnerung versendet |
| 3 | Unterwegs (Rechnung) | Automatische Rechnung ausgestellt |
| 4 | Abgeschlossen | Bezahlt oder zurückgegeben |

## Verwandte Artikel

- [Interne vs. externe Standorte](/app/help?article=internal-vs-external-locations)
- [Wie das Inventar entsteht](/app/help?article=how-inventory-works)
- [Analysen lesen](/app/help?article=viewing-analytics)
